import { Action, createReducer, on } from '@ngrx/store';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './sent-emails.action';

import { SentEmails } from './sent-emails.model';

export interface SentEmailsRecordsState {
    listData: any[];
    total: number;
    singleData: SentEmails;
    loading: boolean;
    error: any;
}

export const initialState: SentEmailsRecordsState = {
    listData: [],
    total: 0,
    singleData: null,
    loading: false,
    error: null,
};


export const SentEmailsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
);